var map = {
	"./lesson_7_1.pdf": 1020,
	"./lesson_7_2.pdf": 1021,
	"./lesson_7_3.pdf": 1022,
	"./lesson_7_4.pdf": 1023,
	"./lesson_7_5.pdf": 1024,
	"./lesson_7_6.pdf": 1025,
	"./lesson_7_7.pdf": 1026,
	"./lesson_7_8.pdf": 1027
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1019;